import { ToastType } from 'shared-types/SharedTypes';

export interface IErrorState {
  errorTitle?: string;
  errorMessage: string;
  accordionTitle?: string;
  errorSeverity?: ToastType;
  accordionDetail: string;
  isErrorShowing?: boolean;
  isOffline?: boolean;
  errorCategory?: string; // used for grouping errors of same category and clearing them
  extraButton?: { text: string; cb: () => void };
  secondButton?: { text: string; cb: () => void };
}

export const NETWORK_ERR_CAT = 'NetworkErrorCategory';
